import { useState, useEffect } from 'react';

export function useDialogCheck() {
  const [exists, setExists] = useState(false);

  useEffect(() => {
    const check = () => setExists(!!document.querySelector('[role="dialog"]'));
    check();

    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return exists;
}